import { parseUrl } from 'searchband-frontend-commons/util/url';

/**
 * Паресер/валидатор url
 * @param {String} urlAsString
 * @return {String}
 */
export default (function () {
    var urlAsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var url = parseUrl(urlAsString);

    if (!url) {
        return '';
    }

    return url.toString();
});